module.exports = __webpack_public_path__ + "img/pla.4e9d33f6.png";